import { type Gate } from '@grammarly/experimentation-js-sdk'

export const Gates: Record<string, Gate> = {
  // Example Statsig gate - update with actual gates as needed
  // ExampleGate: new Gate('example_gate', 'enabled'),
} as const

export const GatesNameSet: Set<string> = new Set(Object.values(Gates).map(gate => gate.name))
